import { useParams } from "react-router-dom";

import { useRetrieveDesignElementById } from "./useRetrieveDesignElementById";
import { useRetrieveDesignElementHistory } from "./useRetrieveDesignElementHistory";

type DrawerParams = {
  selectedItemId: string;
  version: string;
};

export const useDeleteElementDrawer = () => {
  const { selectedItemId, version = "v0" } =
    useParams<DrawerParams>() as DrawerParams;

  const designElement = useRetrieveDesignElementById(selectedItemId, version);
  const designElementHistory = useRetrieveDesignElementHistory(selectedItemId);

  return {
    isLoading: designElement.isLoading || designElementHistory.isLoading,
    designElement: designElement.data,
    designElementHistory: designElementHistory.data,
    version,
  };
};
